/*jshint esversion: 11 */

/**
 * Oferta pública do evento (esgotado, menor preço, restantes) atualizada por polling leve.
 * O servidor já renderiza o estado inicial (SEO/sem JS); aqui o navegador só o mantém fresco:
 *  - consulta GET /event-offer/{id} (sem cookie, ETag/304, servido da tabela do Octane);
 *  - 3 s no começo, com jitter; vai espaçando (8 s, 20 s) enquanto nada muda;
 *  - pausa com a aba oculta ou sem interação por 5 min, e retoma ao voltar;
 *  - 404 (evento encerrado/privado) ou 403 (token vencido) para de vez; erro de rede/5xx recua exponencialmente.
 * O endpoint não é uma API pública: exige o token assinado emitido junto com a página (header X-Page-Token).
 * A venda nunca depende disto: addToCart/startPayment decidem no servidor.
 */
window.eventOffer = (initial, url, enabled = true, token = null) => ({
    offer: initial,
    token,
    showSticky: false,
    timer: null,
    unchanged: 0,
    failures: 0,
    lastActivity: Date.now(),
    stopped: false,

    init() {
        if (!enabled || !url) {
            return;
        }

        const touch = () => {
            const wasIdle = Date.now() - this.lastActivity > 300000;
            this.lastActivity = Date.now();
            if (wasIdle) {
                this.unchanged = 0;
                this.schedule(0);
            }
        };

        // AbortController: um único abort() remove todos os listeners quando o componente é destruído.
        this.controller = new AbortController();
        const options = {passive: true, signal: this.controller.signal};

        ['pointerdown', 'keydown', 'scroll', 'touchstart'].forEach((name) => window.addEventListener(name, touch, options));
        document.addEventListener('visibilitychange', () => {
            if (!document.hidden) {
                this.unchanged = 0;
                this.schedule(0);
            }
        }, {signal: this.controller.signal});

        this.schedule(this.nextDelay());
    },

    destroy() {
        this.stopped = true;
        clearTimeout(this.timer);
        if (this.controller) this.controller.abort();
    },

    nextDelay() {
        if (this.failures > 0) {
            return Math.min(30000, 3000 * 2 ** this.failures);
        }

        return this.unchanged < 5 ? 3000 : this.unchanged < 15 ? 8000 : 20000;
    },

    schedule(ms) {
        if (this.stopped) {
            return;
        }

        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.poll(), ms + Math.random() * 1000);
    },

    async poll() {
        if (this.stopped) {
            return;
        }

        if (document.hidden || Date.now() - this.lastActivity > 300000) {
            return; // retoma sozinho no visibilitychange/atividade
        }

        try {
            const response = await fetch(url, {credentials: 'omit', cache: 'no-cache', headers: {Accept: 'application/json', 'X-Page-Token': this.token || ''}});

            // O servidor renova o token a cada resposta (a página pode ficar aberta por horas).
            this.token = response.headers.get('X-Page-Token') || this.token;

            // 404: evento encerrado/privado. 403: token vencido (aba parada por muitas horas) — para em vez de insistir;
            // a venda continua protegida no servidor e uma recarga traz um token novo.
            if (response.status === 404 || response.status === 403) {
                this.stopped = true;

                return;
            }

            if (!response.ok) {
                throw new Error(response.status);
            }

            const data = await response.json();
            const changed = data.v !== this.offer.v || data.sold_out !== this.offer.sold_out
                || data.remaining !== this.offer.remaining || data.min_price !== this.offer.min_price
                || data.has_tickets !== this.offer.has_tickets;

            if (changed) {
                this.offer = {...this.offer, ...data};
                this.unchanged = 0;
            } else {
                this.unchanged++;
            }

            this.failures = 0;
        } catch (error) {
            this.failures++;
        }

        this.schedule(this.nextDelay());
    },

    money(value) {
        return 'R$ ' + Number(value || 0).toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    },
});
